import { render } from "./WrappedVideo.vue?vue&type=template&id=bd458fbe"
import script from "./WrappedVideo.vue?vue&type=script&lang=js"
export * from "./WrappedVideo.vue?vue&type=script&lang=js"

import "./WrappedVideo.vue?vue&type=style&index=0&id=bd458fbe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__